import "./scss/style.scss";

import heroImg from "./images/mobile/image-hero.jpg";
import navLogo from "./images/logo.svg";
import facebookLogo from "./images/icon-facebook.svg";
import twitterLogo from "./images/icon-twitter.svg";
import pinterestLogo from "./images/icon-pinterest.svg";
import instaLogo from "./images/icon-instagram.svg";

import aboutImgDesktop from "./images/desktop/image-interactive.jpg";
import aboutImgMobile from "./images/mobile/image-interactive.jpg";

import earthImg from "./images/desktop/image-deep-earth.jpg";
import earthImgMobile from "./images/mobile/image-deep-earth.jpg";

import arcadeImg from "./images/desktop/image-night-arcade.jpg";
import arcadeImgMobile from "./images/mobile/image-night-arcade.jpg";

import soccerImg from "./images/desktop/image-soccer-team.jpg";
import soccerImgMobile from "./images/mobile/image-soccer-team.jpg";

import carImg from "./images/desktop/image-grid.jpg";
import carImgMobile from "./images/mobile/image-grid.jpg";

import fromUpImg from "./images/desktop/image-from-above.jpg";
import fromUpImgMobile from "./images/mobile/image-from-above.jpg";

import borealisImg from "./images/desktop/image-pocket-borealis.jpg";
import borealisImgMobile from "./images/mobile/image-pocket-borealis.jpg";

import curiosityImg from "./images/desktop/image-curiosity.jpg";
import curiosityImgMobile from "./images/mobile/image-curiosity.jpg";

import fisheyeImg from "./images/desktop/image-fisheye.jpg";
import fisheyeImgMobile from "./images/mobile/image-fisheye.jpg";

import { useMediaQuery } from "react-responsive";
import { useState, useRef } from "react";

function App() {
  return <Main />;
}

export default App;

function Main() {
  const isMobile = useMediaQuery({ maxWidth: 699.98 });

  return (
    <main>
      <Hero isMobile={isMobile} />
      <About isMobile={isMobile} />
      <Products isMobile={isMobile} />
      <Footer isMobile={isMobile} />
    </main>
  );
}

function Hero({ isMobile }) {
  return (
    <section className="hero">
      {isMobile && (
        <img
          src={heroImg}
          alt="a woman wearing a headset"
          className="hero__img"
        />
      )}
      <div className="hero__container container">
        <Navigation isMobile={isMobile} />
        <div className="hero__header">
          <h1>IMMMERSIVE EXPERIENCES THAT DELIVER</h1>
        </div>
      </div>
    </section>
  );
}

function Navigation({ isMobile }) {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const mobileNav = useRef("");

  function handleNavBtn() {
    setIsMobileNavOpen(!isMobileNavOpen);
    document.body.style.overflow = !isMobileNavOpen ? "hidden" : "";
  }

  function handleAnchorClick(e) {
    e.preventDefault(); // prevent default anchor behavior if it's a link
    const targetId = e.currentTarget.getAttribute("href")?.replace("#", "");
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      const offset = 100;
      const topPosition =
        targetElement.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top: topPosition,
        behavior: "smooth",
      });
      if (isMobileNavOpen) {
        mobileNav.current.classList.remove("nav__open");
        setIsMobileNavOpen(false);
        document.body.style.overflow = "";
      }
    }
  }

  return (
    <nav className="nav">
      <img className="nav__logo" src={navLogo} alt="Loopstudios logo"></img>
      <ul
        className={`nav__links ${isMobileNavOpen ? "nav__open" : ""} `}
        ref={mobileNav}
      >
        <li className="nav__link">
          <a href="#about" rel="noreferrer" onClick={handleAnchorClick}>
            {isMobile ? "About".toUpperCase() : "About"}
          </a>
          <hr></hr>
        </li>
        <li className="nav__link">
          <a href="#careers" rel="noreferrer" onClick={handleAnchorClick}>
            {isMobile ? "Careers".toUpperCase() : "Careers"}
          </a>
          <hr></hr>
        </li>
        <li className="nav__link">
          <a href="#events" rel="noreferrer" onClick={handleAnchorClick}>
            {isMobile ? "Events".toUpperCase() : "Events"}
          </a>
          <hr></hr>
        </li>
        <li className="nav__link">
          <a href="#products" rel="noreferrer" onClick={handleAnchorClick}>
            {isMobile ? "Products".toUpperCase() : "Products"}
          </a>
          <hr></hr>
        </li>
        <li className="nav__link">
          <a href="#support" rel="noreferrer" onClick={handleAnchorClick}>
            {isMobile ? "Support".toUpperCase() : "Support"}
          </a>
          <hr></hr>
        </li>
      </ul>
      <MobileNavMenuBtn
        handleNavBtn={handleNavBtn}
        isMobileNavOpen={isMobileNavOpen}
      />
    </nav>
  );
}

function MobileNavMenuBtn({ handleNavBtn, isMobileNavOpen }) {
  return (
    <button className="nav__mobile--btn" onClick={(e) => handleNavBtn(e)}>
      <ion-icon
        name={`${isMobileNavOpen ? "close" : "menu"}-outline`}
        className="nav-icon"
      ></ion-icon>
    </button>
  );
}

function About({ isMobile }) {
  return (
    <section className="container about" id="about">
      <div className="about__image--box">
        <img
          src={isMobile ? aboutImgMobile : aboutImgDesktop}
          alt="a man wearing a vr device"
        ></img>
      </div>
      <div className="about__text--box">
        <h2>THE LEADER IN INTERACTIVE VR</h2>
        <p>
          Founded in 2011, Loopstudios has been producing world-class virtual
          reality projects for some of the best companies around the globe. Our
          award-winning creations have transformed businesses through digital
          experiences that bind to their brand.
        </p>
      </div>
    </section>
  );
}

function Products({ isMobile }) {
  return (
    <section className={`container products`} id="products">
      <ProductsHeader isMobile={isMobile} />
      <ProductsList isMobile={isMobile} />
      {isMobile && <button className="products__button">SEE ALL</button>}
    </section>
  );
}

function ProductsHeader({ isMobile }) {
  return (
    <header className="products__header">
      <h2>OUR CREATIONS</h2>
      {!isMobile && <button className="products__button">SEE ALL</button>}
    </header>
  );
}

function ProductsList({ isMobile }) {
  return (
    <div className={`products__list grid ${isMobile ? "" : "grid--4-cols"}`}>
      <figure className="products__list--product" tabindex="0">
        <img src={isMobile ? earthImgMobile : earthImg} alt="earth" />
        <h3>DEEP EARTH</h3>
      </figure>

      <figure className="products__list--product" tabindex="0">
        <img src={isMobile ? arcadeImgMobile : arcadeImg} alt="earth" />
        <h3>NIGHT ARCADE</h3>
      </figure>

      <figure className="products__list--product" tabindex="0">
        <img src={isMobile ? soccerImgMobile : soccerImg} alt="earth" />
        <h3>SOCCER TEAM VR</h3>
      </figure>

      <figure className="products__list--product" tabindex="0">
        <img src={isMobile ? carImgMobile : carImg} alt="earth" />
        <h3>THE GRID</h3>
      </figure>

      <figure className="products__list--product" tabindex="0">
        <img src={isMobile ? fromUpImgMobile : fromUpImg} alt="earth" />
        <h3>FROM UP ABOVE VR</h3>
      </figure>

      <figure className="products__list--product" tabindex="0">
        <img src={isMobile ? borealisImgMobile : borealisImg} alt="earth" />
        <h3>ROCKET BOREALIS</h3>
      </figure>

      <figure className="products__list--product" tabindex="0">
        <img src={isMobile ? curiosityImgMobile : curiosityImg} alt="earth" />
        <h3>THE CURIOSITY</h3>
      </figure>

      <figure className="products__list--product" tabindex="0">
        <img src={isMobile ? fisheyeImgMobile : fisheyeImg} alt="earth" />
        <h3>MAKE IT FISHEYE</h3>
      </figure>
    </div>
  );
}

function Footer({ isMobile }) {
  return (
    <footer className="footer" id="support">
      <div className="container">
        <div className="footer__first--row">
          <img
            className="footer__logo"
            src={navLogo}
            alt="Loopstudios logo"
          ></img>
          {isMobile ? <FooterLinks /> : <FooterSocials />}
        </div>
        <div className="footer__second--row">
          {isMobile ? <FooterSocials /> : <FooterLinks />}
          <p className="footer__copyright">
            &copy; <span>{new Date().getFullYear()}</span> Loopstudios, All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

function FooterSocials() {
  return (
    <div className="footer__socials">
      <img
        className="footer__social--logo"
        src={facebookLogo}
        alt="facebook logo"
        tabindex="0"
      ></img>
      <img
        className="footer__social--logo"
        src={twitterLogo}
        alt="twitter logo"
        tabindex="0"
      ></img>
      <img
        className="footer__social--logo"
        src={pinterestLogo}
        alt="pinterest logo"
        tabindex="0"
      ></img>
      <img
        className="footer__social--logo"
        src={instaLogo}
        alt="instagram logo"
        tabindex="0"
      ></img>
    </div>
  );
}

function FooterLinks() {
  return (
    <ul className="footer__links">
      <li className="footer__link">
        <a href="-" rel="noreferrer">
          About
        </a>
        <hr></hr>
      </li>
      <li className="footer__link">
        <a href="-" rel="noreferrer">
          Careers
        </a>
        <hr></hr>
      </li>
      <li className="footer__link">
        <a href="-" rel="noreferrer">
          Events
        </a>
        <hr></hr>
      </li>
      <li className="footer__link">
        <a href="-" rel="noreferrer">
          Products
        </a>
        <hr></hr>
      </li>
      <li className="footer__link">
        <a href="-" rel="noreferrer">
          Support
        </a>
        <hr></hr>
      </li>
    </ul>
  );
}
